'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _browser = require('@beastshop/browser');

var _browser2 = _interopRequireDefault(_browser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var weixin = _browser2.default.weixin();

var Adapter = function () {
  function Adapter() {
    (0, _classCallCheck3.default)(this, Adapter);

    this.callbacks = [];
    this._init();
  }

  (0, _createClass3.default)(Adapter, [{
    key: '_init',
    value: function _init() {
      var _this = this;

      if (weixin) {
        if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
          document.addEventListener('WeixinJSBridgeReady', function () {
            _this._ready();
          }, false);
        } else {
          this._ready();
        }
      } else {
        this._ready();
      }
    }
  }, {
    key: '_ready',
    value: function _ready() {
      this.ready = true;
      this.env = this._env();
      this.callbacks.forEach(function (callback) {
        callback();
      });
      this.callbacks = [];
    }
  }, {
    key: '_env',
    value: function _env() {
      return window.__wxjs_environment === 'miniprogram' ? 'miniprogram' : _browser2.default.weixin() ? 'wx-web' : _browser2.default.app() ? 'app' : 'm-web';
    }
  }, {
    key: 'invoke',
    value: function invoke(callback) {
      if (this.ready) {
        return callback();
      }
      this.callbacks.push(callback);
    }
  }]);
  return Adapter;
}();

exports.default = Adapter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/sdk/lib/lib/adapter.js
// module id = 983
// module chunks = 0